import { Enum1153, description} from "../zugferd_2_3_3/enum1153"
export { Enum1153, description }